import { Space } from '@sravni/react-design-system/lib/Space';
import { Heading } from '@sravni/react-design-system/lib/Typography';
import {
  ServerErrorMessage,
  GetOTPButton,
  useBehaviourState,
  PhoneInput,
} from '@sravni/react-silent-authentication-form';

import { AuthenticationTexts } from 'entities/Authentication/config/texts';
import type { AuthScreenProps } from 'entities/Authentication/types';

export function AuthInitialScreen({ content }: AuthScreenProps) {
  const { isLoading } = useBehaviourState();

  return (
    <>
      <Heading level={5} size={16}>
        {AuthenticationTexts.InitialScreen.title}
      </Heading>
      <PhoneInput />

      <ServerErrorMessage />
      <Space direction="row" align="center" size={8} justify="space-between">
        <div>{content}</div>
        <div>
          <GetOTPButton size={44} loading={isLoading} />
        </div>
      </Space>
    </>
  );
}
